import React, { useState, useEffect, Link } from 'react';
import axios from 'axios';
import ReCAPTCHA from "react-google-recaptcha";
import AdSense from 'react-adsense';
import { Cookies } from '../../index.js';
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { animateScroll as scroll } from 'react-scroll';
import { RingLoader } from "react-spinners";
import { isMobile } from 'react-device-detect';
import Select from 'react-select';
import { alert_error, alert_success } from '../../AppContext';
function Rutgonlink() {
    const navigate = useNavigate();
    const recaptchaRef = React.createRef();
    const [inputmota, setinputmotat] = useState('');
    const [taikhoan, settaikhoan] = useState('');
    const [social, setSocial] = useState('AUTO');
    const [nutorder, setnutorder] = useState('Please wait a moment 😊');
    const [thanhcong2, setthanhcong2] = useState('');
    const [nutxuly, setnutxuly] = useState(1);
    const [service, setservice] = useState('');
    const [quantity] = useState(1);
    const [captcha, setcaptcha] = useState('');
    const [content, setcontent] = useState('');
    const [hanmuc, sethanmuc] = useState('');
    const [chietkhau, setchietkhau] = useState('');
    const [options, setoptions] = useState([
        {
            id: '1', stt: 'GARENA', name: 'Please wait a moment 😊',
            value: 'Garena', status: 'show', content: ''
        },
    ]);
    const [options2, setoptions2] = useState([
        {
            id: '1', stt: 'AUTO', name: 'Tự động',
            value: 'AUTO', status: 'show', content: ''
        },
        {
            id: '2', stt: 'mobifone', name: 'MOBIFONE',
            value: 'mobifone', status: 'show', content: ''
        },
        {
            id: '3', stt: 'vinaphone', name: 'VINAPHONE',
            value: 'vinaphone', status: 'show', content: ''
        },
        {
            id: '4', stt: 'viettel', name: 'VIETTEL',
            value: 'viettel', status: 'show', content: ''
        },
        {
            id: '5', stt: 'vietnamobile', name: 'VIETNAMOBILE',
            value: 'vietnamobile', status: 'show', content: ''
        },
    ]);

    const [options3, setoptions3] = useState([
        {
            id: '1', stt: '', name: 'Thẻ 10.000 (10K)',
            value: '10000', status: 'show', content: '', servicecode: ''
        },
        {
            id: '2', stt: '', name: 'Thẻ 20.000 (20K)',
            value: '20000', status: 'show', content: '', servicecode: ''
        }
    ]);
    function gopdulieu(response) {
        const arr1 = [
            {
                id: '', stt: '', name: 'Chọn 1 nền tảng',
                money: '', status: 'show', content: '', servicecode: ''
            }
        ];

        const arr2 = response.data;

        setoptions(arr1.concat(arr2));

    };

    function laydulieu() {
        axios
            .post('https://nginx.hust.media/go/otp/process/getlist', {
                category: 'buycard'
            })
            .then(response => okluon(response))
            .catch(error => console.log(error))
    };

    function okluon(response) {
        const info = response.data;
        setoptions(info);
        setnutxuly(0);
        setnutorder('✔️ Click to Confirm')
        // alert_success('Thanks');
    };
    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        const message = info.message;

        setnutxuly(0);
        if (status == 0) {
            setnutorder('đặt tiếp luôn nào')
            alert_error(info.message);
        }
        else if (status == 1) {
            setnutorder('Thành công')
            alert_success(info.message);
            setthanhcong2(info.amount);
            setTimeout(() => {
                navigate('/shop/phone/sms/history');
            }, 900);
            return;
        }
        else if (status == 5) {
            sethanmuc(info.hanmuc);
            setchietkhau(info.chietkhau);
            settaikhoan(info.taikhoan);
        }
        else {
            setnutorder('đã xảy ra lỗi vui lòng liên hệ admin')
        }
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1700);
        }
    };
    const scrollToBottom = () => {
        scroll.scrollToBottom({ duration: 200 }); // Cuộn xuống hết trang trong 800ms
    };
    function handleSubmit(event) {
        setnutxuly(0);
        const apikey = Cookies.get('apikey');
        event.preventDefault();

        setnutxuly(1);
        setnutorder('Please wait a moment 😊');
        if (!social || !service) {
            alert_error('Please điền đầy đủ thông tin')
            setnutxuly(0);
            setnutorder('điền đủ thông tin');
            return
        }
        axios
            .post('https://nginx.hust.media/go/otp/process/orders', {
                quantity: quantity,
                apikey: apikey,
                service: service,
                captcha: captcha,
                chedo: 'buycard',
                social: social
            })
            .then(response => (testFunction(response)))
            .catch(error => (alert_error(error),
                setnutxuly(0),
                window.grecaptcha.reset()))

    }

    function saochep(value) {
        alert_success('Đã sao chép');
        window.saochepnative(value);
    };
    const [isOpen, setIsOpen] = useState(true);
    const [isOpen2, setIsOpen2] = useState(false);
    const [isOpen3, setIsOpen3] = useState(false);
    const handleFocus = () => {
        setIsOpen(true);
        console.log(123);
    };
    const handleFocus2 = () => {
        setIsOpen2(true);
        console.log(123);
    };

    const handleBlur = () => {
        setIsOpen(false);
    };
    const handleBlur2 = () => {
        setIsOpen2(false);
    };

    const handleMenuOpen = () => {
        setIsOpen(true);
    };
    const handleMenuOpen2 = () => {
        setIsOpen2(true);
    };

    const handleOptionChange = (selectedOption) => {
        setIsOpen(false);
        const selectedOptionpro = selectedOption.value;
        setservice(selectedOptionpro);
        const selectedOptionok = options.find((option) => option.id == selectedOptionpro);
        setcontent(selectedOptionok);
        // Thêm các hành động khác tại đây dựa trên lựa chọn của người dùng
    }
    const handleOptionChange2 = (selectedOption) => {
        setIsOpen2(false);
        const selectedOptionpro = selectedOption.value;
        const selectedOptionok = options2.find((option) => option.id == selectedOptionpro);
        setSocial(selectedOptionok.value);
    }

    const [type_user, settype_user] = useState('');
    useEffect(() => {
        laydulieu();
        thongtintk();
    }, []);
    function thongtintk() {
        const domain = window.location.hostname;
        // setnutxuly(0);
        const apikey = Cookies.get('apikey');
        axios
            .get('https://hust.media/jop/pay/checktk.php?apikey=' + apikey + '&chedo=buycard' + '&domain=' + domain)
            .then(response => testFunction(response))
            .catch(error => alert_error(error))
    };

    return (
        <>
            <Helmet>
                <title>Cho Thuê Sim Code OTP SMS</title>
            </Helmet>

            <div>
                <div className="mt-0 mx-2">
                    <form className="add-form">
                        <div className="mt-2 form-control">
                            <div className="row align-items-center">
                                <div className="col mb-0">
                                    <div className="col text-left">
                                        <label>Chọn nền tảng:</label>
                                    </div>
                                </div>
                            </div>
                            <Select
                                classNamePrefix="Chọn 1 lựa chọn"
                                onFocus={handleFocus}
                                options={options.map((option) => ({
                                    value: option.id,
                                    label: `${option.name} ${option.money} Coins`
                                }))}
                                menuIsOpen={isOpen}
                                onBlur={handleBlur}
                                onMenuOpen={handleMenuOpen}
                                onChange={handleOptionChange}
                                isDisabled={false}
                                isLoading={false}
                                isClearable={true}
                                isRtl={false}
                                isSearchable={true}
                            >


                            </Select>
                            <div className="row align-items-center">
                                <div className="col mb-0">
                                    <div className="col text-left">
                                        <label>Chọn nhà mạng</label>
                                    </div>
                                </div>
                            </div>
                            <Select
                                classNamePrefix="Chọn 1 lựa chọn"
                                onFocus={handleFocus2}
                                options={options2.map((option) => ({
                                    value: option.id,
                                    label: `${option.name}`
                                }))}
                                defaultValue={{
                                    value: options2[0].id,
                                    label: `${options2[0].name}`
                                }}
                                menuIsOpen={isOpen2}
                                onBlur={handleBlur2}
                                onMenuOpen={handleMenuOpen2}
                                onChange={handleOptionChange2}
                                isDisabled={false}
                                isLoading={false}
                                isClearable={true}
                                isRtl={false}
                                isSearchable={false}
                            >
                            </Select>
                            <div className="relative mt-2 p-2 rounded-md border-2 border-pink-500 bg-white">

                                <div className="text-xs lg:text-base">
                                    🌟 Nền tảng: {content.name}
                                </div>
                                <div className="text-xs lg:text-base">
                                    🏷️ Giá trị số: {(quantity * content.money * (100 - chietkhau) / 100).toFixed(0)} Coins
                                </div>
                                {chietkhau && (
                                    <div className="text-xs lg:text-base">
                                        🎁 Chiết khấu: {chietkhau}
                                        %<span className="ml-2">&#10132;</span>
                                        <span className="text-gray-600">
                                            Tặng 1 ưu đãi miễn phí cho lần tiếp theo
                                        </span>
                                    </div>)}
                                <div className="absolute top-0 left-0 w-full h-full rounded-md border-2 border-pink-500 opacity-0 transition-opacity duration-300 hover:opacity-100"></div>
                            </div>
                            {
                                window.location.hostname == 'hust.media' &&
                                (<>
                                    <div className="flex flex-wrap  justify-center">
                                        <iframe
                                            data-aa="2271984"
                                            src="//ad.a-ads.com/2271984?size=320x50"
                                            frameBorder="0"
                                            scrolling="no"
                                            allowFullScreen
                                            style={{
                                                width: '320px',
                                                height: '50px',
                                                border: 0,
                                                padding: 0,
                                                overflow: 'hidden',
                                                backgroundColor: 'transparent'
                                            }}
                                        ></iframe>
                                        <iframe
                                            data-aa="2271984"
                                            src="//ad.a-ads.com/2271984?size=320x50"
                                            frameBorder="0"
                                            scrolling="no"
                                            allowFullScreen
                                            style={{
                                                width: '320px',
                                                height: '50px',
                                                border: 0,
                                                padding: 0,
                                                overflow: 'hidden',
                                                backgroundColor: 'transparent'
                                            }}
                                        ></iframe>
                                    </div>
                                </>)
                            }
                        </div>

                        {/* <div className='mt-1 mb-0 text-xs'>    {taikhoan}</div> */}


                        <button disabled={nutxuly == 1} onClick={handleSubmit}
                            className='mt-2 mb-1 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2  w-full dark:bg-slate-800 dark:text-white'>
                            <div className='flex items-center justify-between flex-1'>
                                {nutxuly == 1 &&
                                    <div className="spinner-border" role="status">

                                    </div>}


                                <span className='text-lg font-medium text-white'>
                                    {nutorder} </span>
                                <div className="text-xl">
                                    {'\u27A4'}
                                </div>
                            </div>
                        </button>

                        <div className='mt-1 mb-0 text-base'>Mô tả</div>
                        <div className='mt-0 text-sm'>Nếu ko nhận được otp sẽ tự động hoàn tiền trong 12 phút.
                        </div>
                        {/* <a target="_blank" href="/shop/content/blog_posts/freefltiktok/36"> Ấn đây để xem cách tính hạn mức rút tiền </a>
 */}

                    </form>





                </div>

                <br></br>
            </div>    </>
    )
}

export default Rutgonlink;